import { c as _c } from "react/compiler-runtime";
import { Button } from '@repo/design-system/components/ds/button';
import { Icon } from '@repo/design-system/components/ds/icon';
import { FlexColumn } from '@repo/design-system/components/layout/flex-column';
import { FlexRow } from '@repo/design-system/components/layout/flex-row';
import { Checkbox } from '@repo/design-system/components/ui/checkbox';
import { Modal } from '@repo/design-system/components/ui/modal';
import { Select, SelectItem } from '@repo/design-system/components/ui/select';
import { TextInput } from '@repo/design-system/components/ui/text-input';
import { toast } from '@repo/design-system/components/ui/toaster';
import { Type } from '@repo/design-system/components/ui/type';
import { css } from '@repo/panda/css';
import { useBulkUpdateMapPinsMutation, useDeleteMapLocationFeatureMutation } from '@repo/store/maps/api/mapsApi';
import { useAppDispatch, useAppSelector } from '@repo/store/maps/hooks';
import { clearSelectedMarkerIds, selectExternalMapId, selectMapData, selectSelectedMarkerIds, updateMapLocationFeatures } from '@repo/store/maps/slices/mapData';
import { useMemo, useState } from 'react';
import { buildBulkEditPayload, selectAffectedFeatures } from './bulk-edit-pins-payload';
import { BulkMoveSelectedPinsAction } from './bulk-move-selected-pins';
import { BulkSelectMapPinsAction } from './bulk-select-map-pins';
export const BulkEditMapPinsForm = () => {
  const $ = _c(120);
  const dispatch = useAppDispatch();
  const externalMapId = useAppSelector(selectExternalMapId);
  const mapData = useAppSelector(selectMapData);
  const selectedMarkerIds = useAppSelector(selectSelectedMarkerIds);
  const [bulkUpdateMapPins, t0] = useBulkUpdateMapPinsMutation();
  const {
    isLoading
  } = t0;
  const [deleteMapLocationFeature] = useDeleteMapLocationFeatureMutation();
  const [isDeleting, setIsDeleting] = useState(false);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [isApplyOpen, setIsApplyOpen] = useState(false);
  const [deleteProgress, setDeleteProgress] = useState(0);
  const [subcategoryExternalId, setSubcategoryExternalId] = useState("");
  const [descriptionText, setDescriptionText] = useState("");
  const [clearDescriptions, setClearDescriptions] = useState(false);
  const description = clearDescriptions ? "" : descriptionText === "" ? null : descriptionText;
  let t1;
  if ($[0] !== mapData?.metadata?.subcategories) {
    t1 = mapData?.metadata?.subcategories ?? [];
    $[0] = mapData?.metadata?.subcategories;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const subcategories = t1;
  let t2;
  if ($[2] !== selectedMarkerIds) {
    t2 = new Set(selectedMarkerIds);
    $[2] = selectedMarkerIds;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const chosen = t2;
  let t3;
  if ($[4] !== mapData?.geojson.features) {
    t3 = mapData?.geojson.features ?? [];
    $[4] = mapData?.geojson.features;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== chosen || $[7] !== t3) {
    let t5;
    if ($[9] !== chosen) {
      t5 = feature => !feature.properties.isCustomPin && chosen.has(feature.properties.externalId);
      $[9] = chosen;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    t4 = t3.filter(t5);
    $[6] = chosen;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const selectedFeatures = t4;
  const hasChange = subcategoryExternalId !== "" || description !== null;
  let t5;
  if ($[11] !== description || $[12] !== selectedFeatures || $[13] !== subcategoryExternalId) {
    t5 = selectAffectedFeatures(selectedFeatures, {
      subcategoryExternalId,
      description
    });
    $[11] = description;
    $[12] = selectedFeatures;
    $[13] = subcategoryExternalId;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  const affectedFeatures = t5;
  let t6;
  bb0: {
    if (description === null) {
      t6 = null;
      break bb0;
    }
    const sample = affectedFeatures[0];
    if (!sample) {
      t6 = null;
      break bb0;
    }
    const t7 = sample.properties.description ?? "";
    let t8;
    if ($[15] !== description || $[16] !== t7) {
      t8 = {
        before: t7,
        after: description
      };
      $[15] = description;
      $[16] = t7;
      $[17] = t8;
    } else {
      t8 = $[17];
    }
    t6 = t8;
  }
  const example = t6;
  let t7;
  if ($[18] !== affectedFeatures || $[19] !== bulkUpdateMapPins || $[20] !== description || $[21] !== dispatch || $[22] !== externalMapId || $[23] !== hasChange || $[24] !== subcategoryExternalId) {
    t7 = async () => {
      if (!externalMapId || affectedFeatures.length === 0 || !hasChange) {
        return;
      }
      setIsApplyOpen(false);
      ;
      try {
        await bulkUpdateMapPins({
          gameMapExternalId: externalMapId,
          pins: buildBulkEditPayload(affectedFeatures, {
            subcategoryExternalId,
            description
          })
        }).unwrap();
        toast({
          title: "Pins updated",
          description: `${affectedFeatures.length} pins changed in one go.`,
          variant: "success"
        });
        setSubcategoryExternalId("");
        setDescriptionText("");
        setClearDescriptions(false);
        dispatch(clearSelectedMarkerIds());
      } catch (t8) {
        const error = t8;
        toast({
          title: "Bulk edit failed",
          description: error instanceof Error ? error.message : JSON.stringify(error),
          variant: "error"
        });
      }
    };
    $[18] = affectedFeatures;
    $[19] = bulkUpdateMapPins;
    $[20] = description;
    $[21] = dispatch;
    $[22] = externalMapId;
    $[23] = hasChange;
    $[24] = subcategoryExternalId;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  const handleApply = t7;
  let t8;
  if ($[26] !== deleteMapLocationFeature || $[27] !== dispatch || $[28] !== externalMapId || $[29] !== mapData?.geojson || $[30] !== selectedFeatures) {
    t8 = async () => {
      if (!externalMapId || selectedFeatures.length === 0) {
        return;
      }
      setIsDeleteOpen(false);
      setIsDeleting(true);
      setDeleteProgress(0);
      let removed = 0;
      const failed = [];
      for (const feature_0 of selectedFeatures) {
        try {
          await deleteMapLocationFeature({
            location: feature_0,
            gameMapExternalId: externalMapId
          }).unwrap();
          removed = removed + 1;
        } catch {
          failed.push(feature_0.properties.externalId);
        }
        setDeleteProgress(removed + failed.length);
      }
      setIsDeleting(false);
      setDeleteProgress(0);
      if (removed > 0) {
        const failedIds = new Set(failed);
        const deletedIds = new Set(selectedFeatures.map(_temp).filter(id => !failedIds.has(id)));
        const remaining = (mapData?.geojson.features ?? []).filter(feature_2 => feature_2.properties.isCustomPin || !deletedIds.has(feature_2.properties.externalId));
        dispatch(updateMapLocationFeatures(remaining));
      }
      dispatch(clearSelectedMarkerIds());
      toast({
        title: failed.length === 0 ? `${removed} pins deleted` : `${removed} deleted, ${failed.length} failed`,
        description: failed.length === 0 ? "Already-published pins are queued for removal and still need approving in Nova." : `Could not delete: ${failed.slice(0, 5).join(", ")}${failed.length > 5 ? "\u2026" : ""}`,
        variant: failed.length === 0 ? "success" : "error"
      });
    };
    $[26] = deleteMapLocationFeature;
    $[27] = dispatch;
    $[28] = externalMapId;
    $[29] = mapData?.geojson;
    $[30] = selectedFeatures;
    $[31] = t8;
  } else {
    t8 = $[31];
  }
  const handleDelete = t8;
  if (selectedFeatures.length === 0) {
    let t9;
    if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = <FlexColumn gap="8"><Type variant="body-xs" color="text.secondary">Pick the pins you want to change, then edit them all together.</Type><BulkSelectMapPinsAction /></FlexColumn>;
      $[32] = t9;
    } else {
      t9 = $[32];
    }
    return t9;
  }
  const t9 = selectedFeatures.length === 1 ? "" : "s";
  let t10;
  if ($[33] !== selectedFeatures.length || $[34] !== t9) {
    t10 = <FlexRow gap="8" align="center" justify="between"><Type variant="body-s" color="white">{selectedFeatures.length} pin{t9} selected</Type></FlexRow>;
    $[33] = selectedFeatures.length;
    $[34] = t9;
    $[35] = t10;
  } else {
    t10 = $[35];
  }
  let t11;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <BulkSelectMapPinsAction />;
    $[36] = t11;
  } else {
    t11 = $[36];
  }
  let t12;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = value => setSubcategoryExternalId(value);
    $[37] = t12;
  } else {
    t12 = $[37];
  }
  let t13;
  if ($[38] !== subcategories || $[39] !== subcategoryExternalId) {
    t13 = subcategoryExternalId === "" ? "Leave unchanged" : subcategories.find(s => s.externalId === subcategoryExternalId)?.title ?? "Leave unchanged";
    $[38] = subcategories;
    $[39] = subcategoryExternalId;
    $[40] = t13;
  } else {
    t13 = $[40];
  }
  let t14;
  if ($[41] !== t13) {
    t14 = <Button color="secondary" size="sm">{t13}</Button>;
    $[41] = t13;
    $[42] = t14;
  } else {
    t14 = $[42];
  }
  let t15;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <SelectItem item={{
      label: "Leave unchanged",
      value: ""
    }}>Leave unchanged</SelectItem>;
    $[43] = t15;
  } else {
    t15 = $[43];
  }
  let t16;
  if ($[44] !== subcategories) {
    t16 = subcategories.map(_temp2);
    $[44] = subcategories;
    $[45] = t16;
  } else {
    t16 = $[45];
  }
  let t17;
  if ($[46] !== subcategoryExternalId || $[47] !== t14 || $[48] !== t16) {
    t17 = <Select label="Change subcategory to" size="sm" fullWidth={true} value={subcategoryExternalId} onValueChange={t12} placeholder="Leave unchanged" aria-label="Change subcategory for the selected pins" trigger={t14}>{t15}{t16}</Select>;
    $[46] = subcategoryExternalId;
    $[47] = t14;
    $[48] = t16;
    $[49] = t17;
  } else {
    t17 = $[49];
  }
  const t18 = clearDescriptions ? "" : descriptionText;
  let t19;
  if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = e => setDescriptionText(e.target.value);
    $[50] = t19;
  } else {
    t19 = $[50];
  }
  let t20;
  if ($[51] !== clearDescriptions || $[52] !== t18) {
    t20 = <TextInput fullWidth={true} size="sm" label="Set description to" value={t18} onChange={t19} placeholder="Leave blank to keep current descriptions" disabled={clearDescriptions} />;
    $[51] = clearDescriptions;
    $[52] = t18;
    $[53] = t20;
  } else {
    t20 = $[53];
  }
  let t21;
  if ($[54] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = details => setClearDescriptions(!!details.checked);
    $[54] = t21;
  } else {
    t21 = $[54];
  }
  let t22;
  if ($[55] !== clearDescriptions) {
    t22 = <Checkbox id="bulk-clear-descriptions" label="Clear all descriptions" size="sm" checked={clearDescriptions} onCheckedChange={t21} />;
    $[55] = clearDescriptions;
    $[56] = t22;
  } else {
    t22 = $[56];
  }
  let t23;
  if ($[57] !== description || $[58] !== selectedFeatures.length) {
    t23 = description !== null && <Type variant="body-xs" color="text.secondary">{description === "" ? `Removes the description from all ${selectedFeatures.length} selected pins.` : `Overwrites the description on all ${selectedFeatures.length} selected pins.`}</Type>;
    $[57] = description;
    $[58] = selectedFeatures.length;
    $[59] = t23;
  } else {
    t23 = $[59];
  }
  let t24;
  if ($[60] !== t20 || $[61] !== t22 || $[62] !== t23) {
    t24 = <FlexColumn gap="4">{t20}{t22}{t23}</FlexColumn>;
    $[60] = t20;
    $[61] = t22;
    $[62] = t23;
    $[63] = t24;
  } else {
    t24 = $[63];
  }
  let t25;
  if ($[64] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = css.raw({
      paddingTop: "4"
    });
    $[64] = t25;
  } else {
    t25 = $[64];
  }
  let t26;
  if ($[65] !== dispatch) {
    t26 = () => dispatch(clearSelectedMarkerIds());
    $[65] = dispatch;
    $[66] = t26;
  } else {
    t26 = $[66];
  }
  let t27;
  if ($[67] !== isLoading || $[68] !== t26) {
    t27 = <Button variant="ghost" onClick={t26} color="secondary" size="sm" disabled={isLoading}>Clear selection</Button>;
    $[67] = isLoading;
    $[68] = t26;
    $[69] = t27;
  } else {
    t27 = $[69];
  }
  let t28;
  if ($[70] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = () => setIsApplyOpen(true);
    $[70] = t28;
  } else {
    t28 = $[70];
  }
  const t29 = isLoading || isDeleting || !hasChange || affectedFeatures.length === 0;
  let t30;
  if ($[71] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <Icon icon="check" decorative={true} />;
    $[71] = t30;
  } else {
    t30 = $[71];
  }
  const t31 = isLoading ? "Applying\u2026" : `Apply to ${affectedFeatures.length}`;
  let t32;
  if ($[72] !== t29 || $[73] !== t31) {
    t32 = <Button onClick={t28} color="success" size="sm" disabled={t29}>{t30}{t31}</Button>;
    $[72] = t29;
    $[73] = t31;
    $[74] = t32;
  } else {
    t32 = $[74];
  }
  let t33;
  if ($[75] !== t25 || $[76] !== t27 || $[77] !== t32) {
    t33 = <FlexRow gap="8" justify="end" className={t25}>{t27}{t32}</FlexRow>;
    $[75] = t25;
    $[76] = t27;
    $[77] = t32;
    $[78] = t33;
  } else {
    t33 = $[78];
  }
  let t34;
  if ($[79] === Symbol.for("react.memo_cache_sentinel")) {
    t34 = <BulkMoveSelectedPinsAction />;
    $[79] = t34;
  } else {
    t34 = $[79];
  }
  let t35;
  if ($[80] === Symbol.for("react.memo_cache_sentinel")) {
    t35 = () => setIsDeleteOpen(true);
    $[80] = t35;
  } else {
    t35 = $[80];
  }
  const t36 = isLoading || isDeleting;
  let t37;
  let t38;
  if ($[81] === Symbol.for("react.memo_cache_sentinel")) {
    t37 = css({
      flex: "1",
      whiteSpace: "nowrap"
    });
    t38 = <Icon icon="delete" decorative={true} />;
    $[81] = t37;
    $[82] = t38;
  } else {
    t37 = $[81];
    t38 = $[82];
  }
  const t39 = isDeleting ? `Deleting ${deleteProgress} of ${selectedFeatures.length}…` : `Delete ${selectedFeatures.length}`;
  let t40;
  if ($[83] !== t36 || $[84] !== t37 || $[85] !== t39) {
    t40 = <FlexRow gap="8">{t34}<Button onClick={t35} color="error" size="sm" disabled={t36} className={t37}>{t38}{t39}</Button></FlexRow>;
    $[83] = t36;
    $[84] = t37;
    $[85] = t39;
    $[86] = t40;
  } else {
    t40 = $[86];
  }
  let t41;
  if ($[87] === Symbol.for("react.memo_cache_sentinel")) {
    t41 = details_0 => setIsApplyOpen(details_0.open);
    $[87] = t41;
  } else {
    t41 = $[87];
  }
  const t42 = `Change ${affectedFeatures.length} pins?`;
  const t43 = subcategoryExternalId !== "" ? `All ${affectedFeatures.length} selected pins move to the chosen subcategory.${description !== null ? " Their descriptions are overwritten too." : ""}` : `The description on all ${affectedFeatures.length} selected pins is overwritten.`;
  let t44;
  if ($[88] !== example) {
    t44 = example && <FlexColumn gap="4"><Type variant="body-xs" color="text.secondary">Before</Type><Type variant="body-xs" color="white">{example.before.slice(0, 200)}</Type><Type variant="body-xs" color="text.secondary">After</Type><Type variant="body-xs" color="white">{example.after.slice(0, 200)}</Type></FlexColumn>;
    $[88] = example;
    $[89] = t44;
  } else {
    t44 = $[89];
  }
  let t45;
  if ($[90] === Symbol.for("react.memo_cache_sentinel")) {
    t45 = <Type variant="body-xs" color="text.secondary">There is no undo for a bulk edit.</Type>;
    $[90] = t45;
  } else {
    t45 = $[90];
  }
  let t46;
  if ($[91] === Symbol.for("react.memo_cache_sentinel")) {
    t46 = <Button variant="ghost" onClick={() => setIsApplyOpen(false)} color="secondary" size="sm">Cancel</Button>;
    $[91] = t46;
  } else {
    t46 = $[91];
  }
  let t47;
  if ($[92] === Symbol.for("react.memo_cache_sentinel")) {
    t47 = <Icon icon="check" decorative={true} />;
    $[92] = t47;
  } else {
    t47 = $[92];
  }
  let t48;
  if ($[93] !== handleApply) {
    t48 = <FlexRow gap="4" justify="end">{t46}<Button onClick={handleApply} color="success" size="sm">{t47}Change them</Button></FlexRow>;
    $[93] = handleApply;
    $[94] = t48;
  } else {
    t48 = $[94];
  }
  let t49;
  if ($[95] !== t44 || $[96] !== t48) {
    t49 = <FlexColumn gap="12">{t44}{t45}{t48}</FlexColumn>;
    $[95] = t44;
    $[96] = t48;
    $[97] = t49;
  } else {
    t49 = $[97];
  }
  let t50;
  if ($[98] !== isApplyOpen || $[99] !== t42 || $[100] !== t43 || $[101] !== t49) {
    t50 = <Modal isOpen={isApplyOpen} onOpenChange={t41} title={t42} description={t43} size="sm">{t49}</Modal>;
    $[98] = isApplyOpen;
    $[99] = t42;
    $[100] = t43;
    $[101] = t49;
    $[102] = t50;
  } else {
    t50 = $[102];
  }
  let t51;
  if ($[103] === Symbol.for("react.memo_cache_sentinel")) {
    t51 = details_1 => setIsDeleteOpen(details_1.open);
    $[103] = t51;
  } else {
    t51 = $[103];
  }
  const t52 = `Delete ${selectedFeatures.length} pins?`;
  let t53;
  if ($[104] === Symbol.for("react.memo_cache_sentinel")) {
    t53 = <Button variant="ghost" onClick={() => setIsDeleteOpen(false)} color="secondary" size="sm">Cancel</Button>;
    $[104] = t53;
  } else {
    t53 = $[104];
  }
  let t54;
  if ($[105] === Symbol.for("react.memo_cache_sentinel")) {
    t54 = <Icon icon="delete" decorative={true} />;
    $[105] = t54;
  } else {
    t54 = $[105];
  }
  let t55;
  if ($[106] !== handleDelete) {
    t55 = <FlexRow gap="4" justify="end">{t53}<Button onClick={handleDelete} color="error" size="sm">{t54}Delete them</Button></FlexRow>;
    $[106] = handleDelete;
    $[107] = t55;
  } else {
    t55 = $[107];
  }
  let t56;
  if ($[108] !== isDeleteOpen || $[109] !== t52 || $[110] !== t55) {
    t56 = <Modal isOpen={isDeleteOpen} onOpenChange={t51} title={t52} description="There is no bulk delete on the server yet, so this sends one request per pin and can take a while. Pins that are already published are not removed outright, they are queued for deletion and still need approving in Nova." size="sm">{t55}</Modal>;
    $[108] = isDeleteOpen;
    $[109] = t52;
    $[110] = t55;
    $[111] = t56;
  } else {
    t56 = $[111];
  }
  let t57;
  if ($[112] !== t10 || $[113] !== t17 || $[114] !== t24 || $[115] !== t33 || $[116] !== t40 || $[117] !== t50 || $[118] !== t56) {
    t57 = <FlexColumn gap="12">{t10}{t11}{t17}{t24}{t33}{t40}{t50}{t56}</FlexColumn>;
    $[112] = t10;
    $[113] = t17;
    $[114] = t24;
    $[115] = t33;
    $[116] = t40;
    $[117] = t50;
    $[118] = t56;
    $[119] = t57;
  } else {
    t57 = $[119];
  }
  return t57;
};
function _temp(feature_1) {
  return feature_1.properties.externalId;
}
function _temp2(subcategory) {
  return <SelectItem key={subcategory.externalId} item={{
    label: subcategory.title,
    value: subcategory.externalId
  }}>{subcategory.title}</SelectItem>;
}